import React from 'react';
import { StarIcon } from 'lucide-react';
import { quickTestimonials } from '../data/testimonials';
export function QuickTestimonials() {
  return <section aria-label="What educators say" className="bg-paper py-16 sm:py-20" data-id="element-215" data-mp="3dpqmu27tuxob">
      <div className="mx-auto grid max-w-shell gap-9 px-5 sm:px-6 md:grid-cols-3 md:gap-8" data-id="element-216" data-mp="2zq8vbf35d6b9">
        {quickTestimonials.map(item => <figure key={item.name} className="flex flex-col" data-id="element-217" data-mp="2q0xoy07nafr2">
            <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-218" data-mp="2pze92apwi6pt">
              {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-brass text-brass" aria-hidden="true" data-id="element-219" data-mp="2h09aj4ecaddn" data-mpi={index} />)}
            </div>
            <blockquote className="mt-5 font-display text-xl leading-snug text-ink sm:text-[1.4rem]" data-id="element-220" data-mp="272d0yh11vqhn">
              &ldquo;{item.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-auto pt-6 text-xs text-ink-muted" data-id="element-221" data-mp="2c0emr9pv23wt">
              <span className="font-semibold text-ink-soft" data-id="element-222" data-mp="2pne2urfnua92">{item.name}</span> &middot; {item.role}{' '}
              &middot; {item.location}
            </figcaption>
          </figure>)}
      </div>
    </section>;
}